import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  allocatioTypeID: '0',
}

const allocationTypeSlice = createSlice({
  name: 'allocation',
  initialState,
  reducers: {
    setAllocationTypeID: (state, action) => {
      state.allocatioTypeID = action.payload
    }
  }
})

export const { setAllocationTypeID } = allocationTypeSlice.actions

export default allocationTypeSlice.reducer